import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";

import { FeatureResponse } from "./type";

export const featureApi = {
  async toggleFeature(username: string) {
    const response = await axiosRequest.post<FeatureResponse>(
      "",
      payloadHelper("ToggleFeature", username, { username })
    );
    return response.data;
  },
};
